import type { QueryClient, QueryKey } from "@tanstack/react-query";

import type { Feature, Module } from "./queryFeatures.ts";

export const EVENTUAL_WRITE_LAG_MS = 3000;

export function queryPath(module: Module, reads: readonly Feature[]) {
    return [module, [...new Set(reads)].toSorted().join(",")];
}

interface InvalidateOptions {
    except?: readonly QueryKey[];
}

export function invalidate(queryClient: QueryClient, features: Feature | readonly Feature[], options: InvalidateOptions = {}) {
    const wanted = typeof features === "string" ? [features] : features;
    const exceptPaths = (options.except ?? []).map(key => key[0]);

    return queryClient.invalidateQueries({
        predicate: query => {
            const path = query.queryKey[0];
            if (!Array.isArray(path)) {
                return false;
            }

            const reads = typeof path[1] === "string" ? path[1].split(",") : [];
            if (!wanted.some(feature => reads.includes(feature))) {
                return false;
            }

            return !exceptPaths.some(exceptPath => Array.isArray(exceptPath) && exceptPath.every((segment, index) => segment === path[index]));
        }
    });
}

export function invalidateAfterLag(queryClient: QueryClient, features: Feature | readonly Feature[]) {
    setTimeout(() => {
        void invalidate(queryClient, features);
    }, EVENTUAL_WRITE_LAG_MS);
}
